import React, { useEffect, useState, useRef } from "react";
import {
    VolumeUp,
    VolumeDown,
    VolumeBelow,
    VolumeMute,
} from "./VolumeControlIcons.js";
import "./VolumeControls.scss";

function VolumeControls(props) {
    //now i need to manage a bunch of states here
    var icons = [<VolumeUp />, <VolumeDown />, <VolumeBelow />, <VolumeMute />];
    var iconStateHelper = {
        high: 0,
        medium: 1,
        low: 2,
        muted: 3,
    };

    var [mouseDown, setMouseDown] = useState(false);
    var [touchDown, setTouchDown] = useState(false);
    var [iconState, setIconState] = useState(3);
    var [barHovered, setBarHovered] = useState(false);
    var [barVisible, setBarVisible] = useState(false);
    var [barCounter, setBarCounter] = useState(0);
    var timeOut = 2000;

    var disVol = props.volume;
    if (props.muted) disVol = 0;

    var rootRef = useRef();
    var barRef = useRef();
    var ballRef = useRef();
    var btnRef = useRef();

    if (props.volume < 0) {
        props.setVolume(0);
    } else if (props.volume > 100) {
        props.setVolume(100);
    }

    var styles = {
        bottom: disVol + "%",
    };

    //bar click / touch listeners
    function barClickStart(e) {
        setMouseDown(true);
    }

    function barClickMove(e) {
        if (mouseDown) {
            var percent = mouseDragPercentageCalculation(e);
            updateVolume(percent);
            if (props.muted) props.setMuted(false);
        }
    }

    function barClickEnd(e) {
        setMouseDown(false);
    }

    function mouseDragPercentageCalculation(e) {
        var mouseY = e.clientY;
        var rect = barRef.current.getBoundingClientRect();

        var top;
        var bottom;
        var point;
        var percent;

        //typical collision check
        if (mouseY > rect.top && mouseY < rect.bottom) {
            top = rect.top;
            bottom = rect.bottom;
            point = mouseY;

            top -= rect.top;
            bottom -= rect.top;
            point -= rect.top;

            percent = point / bottom;
            percent = 1 - percent;
            percent *= 100;
            percent = Math.round(percent);

            //now set our position
        } else if (mouseY < rect.top) {
            percent = 100;
        } else if (mouseY > rect.bottom) {
            percent = 0;
        }

        return percent;
    }

    function barTouchStart(e) {
        e.preventDefault();
        e.stopPropagation();

        setTouchDown(true);
    }

    function barTouchMove(e) {
        if (touchDown == true) {
            e.preventDefault();
            e.stopPropagation();

            var percent = touchDragPercentageCalculation(e);
            console.log(percent);
            updateVolume(percent);
            if (props.muted) props.setMuted(false);
        }
    }

    function touchDragPercentageCalculation(e) {
        if (e.changedTouches.length > 0) {
            var touchY = e.changedTouches[0].clientY;

            var rect = barRef.current.getBoundingClientRect();

            var top;
            var bottom;
            var point;
            var percent;

            //typical collision check
            if (touchY > rect.top && touchY < rect.bottom) {
                top = rect.top;
                bottom = rect.bottom;
                point = touchY;

                top -= rect.top;
                bottom -= rect.top;
                point -= rect.top;

                percent = point / bottom;
                percent = 1 - percent;
                percent *= 100;
                percent = Math.round(percent);

                //now set our position
            } else if (touchY < rect.top) {
                percent = 100;
            } else if (touchY > rect.bottom) {
                percent = 0;
            }

            return percent;
        }

        return 0;
    }

    function barTouchEnd(e) {
        setTouchDown(false);
    }

    function barTouchCancelled(e) {
        setTouchDown(false);
    }

    function toggleMuteButtonClicked() {
        var muted = !props.muted;
        var volume = props.volume;

        props.setMuted(muted);
        updateIconState(volume, muted);
    }

    function updateIconState(volume, muted) {
        if (muted) {
            setIconState(iconStateHelper.muted);
        } else {
            if (volume > 66) {
                setIconState(iconStateHelper.high);
            } else if (volume > 33) {
                setIconState(iconStateHelper.medium);
            } else {
                setIconState(iconStateHelper.low);
            }
        }
    }

    function updateVolume(percent) {
        updateIconState(percent, props.muted);
        props.setVolume(percent);
    }

    function checkForControlBarVisibility() {
        if (!barVisible) {
            setBarVisible(true);
        }

        setBarHovered(true);
    }

    function primeControlBarForHiding() {
        setBarCounter(0);
        setBarHovered(false);
    }

    function hideControlBarVisibility() {
        setBarVisible(false);
    }

    function visibilityLoop() {
        //increase the counter see if we're visible and not hovering
        if (!barHovered && barVisible) {
            var bc = barCounter;
            bc += 1000 / 16;

            if (bc > timeOut) {
                hideControlBarVisibility();
            }

            setBarCounter(bc);
        }

        window.requestAnimationFrame(() => {
            visibilityLoop();
        });
    }

    useEffect(() => {
        //add in the mouse events on the reference
        barRef.current.addEventListener("mousedown", barClickStart);
        ballRef.current.addEventListener("mousedown", barClickStart);
        barRef.current.addEventListener("touchstart", barTouchStart);
        ballRef.current.addEventListener("touchstart", barTouchStart);

        window.addEventListener("mousemove", barClickMove);
        window.addEventListener("mouseup", barClickEnd);

        window.addEventListener("touchmove", barTouchMove);
        window.addEventListener("touchend", barTouchEnd);
        //window.addEventListener("touchcancel", barTouchCancelled);

        btnRef.current.addEventListener("click", toggleMuteButtonClicked);
        rootRef.current.addEventListener(
            "mouseenter",
            checkForControlBarVisibility
        );

        rootRef.current.addEventListener(
            "mouseleave",
            primeControlBarForHiding
        );

        return () => {
            barRef.current.removeEventListener("mousedown", barClickStart);
            ballRef.current.removeEventListener("mousedown", barClickStart);

            window.removeEventListener("mousemove", barClickMove);
            window.removeEventListener("mouseup", barClickEnd);

            window.removeEventListener("touchmove", barTouchMove);
            window.removeEventListener("touchend", barTouchEnd);
            //window.addEventListener("touchcancel", barTouchCancelled);

            btnRef.current.removeEventListener(
                "click",
                toggleMuteButtonClicked
            );
        };
    });

    var controlBarClasses = "bar-container";
    controlBarClasses += " visible";

    return (
        <div class="VolumeControls" ref={rootRef}>
            <button class="volume-button" ref={btnRef}>
                {icons[iconState]}
            </button>
            <div class={controlBarClasses} ref={barRef}>
                <div class="bar">
                    <div class="ball" style={styles} ref={ballRef} />
                </div>
            </div>
        </div>
    );
}

export default VolumeControls;
